import React, { useEffect, useState } from "react";
import { ThreadList } from "./ThreadList";

const backendUrl = process.env.REACT_APP_BACKEND_URL;
const fetchUsers = async () => {
  try {
    const response = await fetch(
      `${backendUrl}/api/users?populate=role&populate=avatar`
    );
    if (!response.ok) throw new Error("Failed to fetch users");
    const data = await response.json();

    return data.map((user) => ({
      id: user.id.toString(),
      value: user.username,
      email: user.email,
      avatar_url: user?.avatar?.url ? `${backendUrl}${user.avatar.url}` : null,
      type: "user",
    }));
  } catch (error) {
    console.error("Error fetching users:", error);
    return [];
  }
};

const fetchHashtags = async () => {
  try {
    const response = await fetch(`${backendUrl}/api/groups`);
    if (!response.ok) throw new Error("Failed to fetch hashtags");
    const data = await response.json();

    return data.data.map((group) => ({
      email: "",
      avatar_url: null,
      id: group.id.toString(),
      value: group.attributes.name,
      type: "group",
    }));
  } catch (error) {
    console.error("Error fetching hashtags:", error);
    return [];
  }
};

let usersData = [];
let groupsData = [];

(async () => {
  usersData = await fetchUsers();
  groupsData = await fetchHashtags();
})();

export { usersData, groupsData };

export default function MentionEditor() {
  const [users, setUsers] = useState([]);
  const [groups, setGroups] = useState([]);
  useEffect(() => {
    setUsers(usersData);
    setGroups(groupsData);
  }, []);

  return <ThreadList users={users} groups={groups} />;
}
